import { Button } from "./button";
import { Heading } from "./heading";
import { Switch } from "./switch";
import { Text } from "./text";

export const components = { Button, Heading, Switch, Text };
